// extracted by mini-css-extract-plugin
module.exports = {"container":"MU","mediaElement":"NU","close":"OU"};